import { ITag } from '@interfaces';
import { ICompanyUserRelated } from '@base/interfaces';
import { IGroup } from '@group/group.structure';

export interface ICompany {
    id?: number;
    name: string;
    slug: string;
    domain: string;
    color: string;
    created_at: Date;
    updated_at: Date;
    users: ICompanyUserRelated[];
    modules: number[];
    groups: number[] | IGroup[];
    image_url: string;
    workbooks: [];
    tag?: string;
    tags?: ITag[];
    tableau_id?: string;
}

export interface ICompanyList {
  count: number;
  next: string;
  previous: string;
  results: Array<ICompany>;
}

export class Company implements ICompany {
    id: number;
    name = '';
    slug = '';
    domain = '';
    color: string;
    created_at: Date;
    updated_at: Date;
    users: [];
    modules: [];
    groups: [];
    image_url: null;
    workbooks: [];
    tags: [];

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
